"use client";

import { c as _c } from "react/compiler-runtime";
import { getImageProps } from "next/image";
import { Children } from "react";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { cn } from "@/lib/utils";
type ImageChildProps = Parameters<typeof getImageProps>[0];
const ImageDiff = t0 => {
  const $ = _c(17);
  const {
    children,
    className
  } = t0;
  const childrenArray = Children.toArray(children);
  if (childrenArray.length !== 2) {
    console.error("ImageDiff must have exactly two children (before and after images)");
    return null;
  }
  const [before, after] = children;
  const imageSrc = before.props.src;
  const aspectRatio = typeof imageSrc === "object" && "width" in imageSrc && "height" in imageSrc ? imageSrc.width / imageSrc.height : 1.7777777777777777;
  let t1;
  if ($[0] !== before.props) {
    t1 = getImageProps(before.props);
    $[0] = before.props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const beforeImageProps = t1.props;
  let t2;
  if ($[2] !== after.props) {
    t2 = getImageProps(after.props);
    $[2] = after.props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const afterImageProps = t2.props;
  let t3;
  if ($[4] !== className) {
    t3 = cn("my-8 w-full max-w-full overflow-hidden rounded-sm", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== aspectRatio) {
    t4 = {
      aspectRatio
    };
    $[6] = aspectRatio;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== beforeImageProps) {
    t5 = <ReactCompareSliderImage {...beforeImageProps} className="size-full object-cover" />;
    $[8] = beforeImageProps;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== afterImageProps) {
    t6 = <ReactCompareSliderImage {...afterImageProps} className="size-full object-cover" />;
    $[10] = afterImageProps;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <ReactCompareSlider className={t3} style={t4} itemOne={t5} itemTwo={t6} suppressHydrationWarning={true} />;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export { ImageDiff };